import { Link, useLocation } from "react-router-dom"; // Assuming you're using react-router-dom for routing
import { Body16Regular } from "../typography/Body16Regular";
import { Body16Strong } from "../typography/Body16Strong";
import { H4 } from "../typography/H4";
import { DrawerWrapper } from "../wrapper/DrawerWrapper";

interface Props {}

const links = [
  { name: "관리자 정보", path: "/profile" },
  { name: "공지사항 관리", path: "/notification" },
];

export const AdminDrawer: React.FC<Props> = ({}) => {
  const location = useLocation();
  return (
    <DrawerWrapper>
      <div className="flex flex-col gap-[16px]">
        <H4>관리자 정보</H4>
        <div className="flex flex-col box-border gap-[12px]">
          {links.map((link) => {
            const isSelect = location.pathname.startsWith(link.path);
            return (
              <div
                key={link.name}
                className={`w-[200px] h-[38px] px-[8px] flex items-center box-border ${
                  isSelect && "bg-grayscale-contrast-5"
                }`}
              >
                <Link
                  key={link.path}
                  to={link.path}
                  className={`cursor-pointer ${
                    isSelect
                      ? "text-semantic-text-body"
                      : "text-semantic-text-secondary"
                  }`}
                >
                  {isSelect ? (
                    <Body16Strong>{link.name}</Body16Strong>
                  ) : (
                    <Body16Regular>{link.name}</Body16Regular>
                  )}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </DrawerWrapper>
  );
};
